import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "card custom-shadow rounded-3 bg-white border mb-4",
  style: {"padding-bottom":"16px"}
}
const _hoisted_2 = { class: "default-table-area style-three recently-played" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle border-0" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "player-container" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "flex-shrink-0" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "flex-grow-1 ms-10" }
const _hoisted_13 = { class: "fs-14 fw-medium mb-0" }
const _hoisted_14 = { class: "fs-12 text-body fw-normal" }
const _hoisted_15 = { class: "d-block fs-14 fw-normal text-body" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "d-block fs-14 fw-normal text-body ms-10" }
const _hoisted_18 = { class: "text-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "d-flex justify-content-between align-items-center flex-wrap gap-3 custom-padding-30 position-relative pb-3",
      style: {"top":"-5px"}
    }, [
      _createElementVNode("h3", { class: "mb-0 fs-18 fw-semibold" }, "Recently Played"),
      _createElementVNode("button", {
        class: "bg-transparent border-0 p-0 d-flex align-items-center text-decoration-none position-relative right-for-rtl text-body",
        style: {"right":"-8px"}
      }, [
        _createElementVNode("span", null, "View All"),
        _createElementVNode("i", { class: "ri-arrow-right-s-line fs-24 position-relative top-1 lh-1 text-body" })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentlyPlayed, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "p-0 border-0 bg-transparent me-3",
                      onClick: ($event: any) => (_ctx.togglePlayback(index))
                    }, [
                      _createElementVNode("audio", {
                        ref_for: true,
                        ref: "audioRefs",
                        class: "track",
                        src: item.audioSrc,
                        type: "audio/mpeg"
                      }, null, 8, _hoisted_7),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: _normalizeClass({
                          'play-pause': true,
                          pause: _ctx.isPlaying === index,
                          play: _ctx.isPlaying !== index,
                        })
                        }, _toDisplayString(_ctx.isPlaying === index ? "Pause" : "Play"), 3)
                      ])
                    ], 8, _hoisted_6),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: item.imageSrc,
                          style: {"width":"34px","height":"34px"},
                          class: "rounded-1",
                          alt: item.title
                        }, null, 8, _hoisted_11)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h4", _hoisted_13, _toDisplayString(item.title), 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.artist), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(item.timePlayed), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-customer-service-line text-primary fs-18" }, null, -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.playCount.toLocaleString()), 1)
                  ])
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                  _createElementVNode("button", { class: "favorite-button border-0 text-body-color-60 fs-14 bg-transparent p-0" }, [
                    _createElementVNode("span", { class: "favorite-icon position-relative" }, [
                      _createElementVNode("i", { class: "ri-heart-line fs-20" }),
                      _createElementVNode("i", { class: "ri-heart-fill fs-20 position-absolute top-50 start-50 translate-middle text-primary" })
                    ])
                  ])
                ], -1)),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(item.duration), 1)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                  _createElementVNode("div", { class: "dropdown action-opt" }, [
                    _createElementVNode("button", {
                      class: "btn bg-transparent p-0",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("i", { "data-feather": "more-horizontal" })
                    ]),
                    _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "plus" }),
                          _createTextVNode(" Add To Playlist ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "file" }),
                          _createTextVNode(" Go To Album ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;"
                        }, [
                          _createElementVNode("i", { "data-feather": "speaker" }),
                          _createTextVNode(" View Credits ")
                        ])
                      ])
                    ])
                  ])
                ], -1))
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}